import React, { useContext } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import { lighten, withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import LibraryPropertiesForm from "./LibraryPropertiesForm";
import { Box, Button, Typography } from "@material-ui/core";
import * as actions from "../actions/actions";
import NewProjectForm from '../components/NewProjectForm';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        height: '100%',
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#ffffff",
    },
    expansion_block: {
        flex: "1 1 0",
        minHeight: 0,
        padding: "10px 10px 0px 10px",
        overflow: "hidden",
        overflowY: "auto",
    },
    content: {
        flex: "1 1 auto",
    },
    expansion_details: {
        padding: "0 !important",
    },
    pannelSummary: {
        padding: "0 16px",
    },
    action_block: {
        textAlign: "center",
        paddingBottom: "10px"
    },
    update_padding: {
        padding: 0,
    },
    button_block: {
        width: '90%',
        margin: '0 5%'
    },
    selectReport: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: "1 1 auto",
        margin: theme.spacing(2),
        textAlign: "center",
    }

}));

const Accordion = withStyles({

    root: {
        border: "1px solid rgba(0, 0, 0, .125)",
        width: "100%",
        backgroundColor: '#ffffff',
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: "#F7F7F7",
        borderBottom: "1px solid #E6E6E6",
        marginBottom: -1,
        minHeight: 40,
        height: 40,
        "&$expanded": {
            minHeight: 40,
            height: 40,
            backgroundColor: "#E6E6E6",
        },
        '&:hover': {
            cursor: "pointer",
            backgroundColor: "#EEEEEE",
            transition: 'background-color 0.2s',
        },
    },

    content: {
        "&$expanded": {
            margin: "12px 0",
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

export default function LibraryDetails(props) {
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const dispatch = useContext(DispatchContext);
    const [expanded, setExpanded] = React.useState("panel1");
    const { libtext, startPlagCheckHandler } = props;

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    if (!libtext || !libtext.Id) {
        return (
            <div className={classes.root}>
                <div className={classes.selectReport}>
                    <LibraryBooksIcon fontSize="large" color="primary" />
                    <Box mt={3} />
                    <Typography paragraph>{s.libraryOverview.selectLibrary}</Typography>
                    <Typography variant="body2" color="primary">{s.libraryOverview.selectLibraryHint}</Typography>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.root}>
            { /* state.openCreateProjectPopup && <NewProjectForm /> */}
            <div className={classes.expansion_block}>

                <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleChange("panel1")}
                >
                    <AccordionSummary
                        className={classes.pannelSummary}
                        aria-controls="panel1d-content"
                        id="panel1d-header"
                    >
                        {s.properties}
                    </AccordionSummary>
                    <AccordionDetails className={classes.expansion_details}>
                        {state.loadingLibraryDetail && <LibraryPropertiesForm className={classes.update_padding} library={libtext} />}
                    </AccordionDetails>
                </Accordion>

                <Accordion
                    square
                    expanded={expanded === "panel4"}
                    onChange={handleChange("panel4")}
                >
                    <AccordionSummary
                        className={classes.pannelSummary}
                        aria-controls="panel4d-content"
                        id="panel4d-header"
                    >
                        {s.actions}
                    </AccordionSummary>
                    <AccordionDetails className={classes.expansion_details}>
                        <div style={{ width: '100%', paddingTop: '10px' }}>
                            <div className={classes.action_block}>
                                <Button className={classes.button_block} disabled={!libtext.HasFulltextAccess || !!libtext.IsFingerprint} variant="contained" color="primary" onClick={(e) => startPlagCheckHandler(e, libtext)}>
                                    {s.startPlagiarism}
                                </Button>
                            </div>

                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={expanded === "panelDetails"}
                    onChange={handleChange("panelDetails")}>
                    <AccordionSummary className={classes.pannelSummary}>
                        {s.common.details}
                    </AccordionSummary>
                    <AccordionDetails className={classes.expansion_details}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", padding: 10 }}>
                            <Typography>{s.libraryOverview.libtextId}: {libtext.Id}</Typography>
                            {!libtext.IsOwner && 
                                <Typography> {s.common.owner + ": " + libtext.Owner}</Typography>
                            }
                        </div>
                    </AccordionDetails>
                </Accordion>

                {/* Action Panel End */}
            </div>
        </div>
    );
};
